import BlogSliderLayoutContainer from "../../../../components/pages/blog/blogDetail/BlogSliderLayout";

const BlogSliderLayout = () => {
  return <BlogSliderLayoutContainer />;
};

export default BlogSliderLayout;
